module.exports = __webpack_public_path__ + "static/img/kjhf_add_group.110b862.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pdd/kjhf_add_group.jpeg
// module id = 1234
// module chunks = 0